<script>
export default {
  name: "DidoApidocUsagePagination",
};
</script>

<script setup>
import DidoCodeHightlighting from "../codeHighlighting/Base.vue";

const codeExamplePagination = `
{
  "data": [{...}, {...}],
  "pageSize": 10,
  "page": 3,
  "total": 27,
  "firstPage": "$BASE_URL_API/datasets?page=1&pageSize=10",
  "nextPage": null,
  "previousPage": "$BASE_URL_API/datasets?page=2&pageSize=10",
  "lastPage": "$BASE_URL_API/datasets?page=3&pageSize=10"
}
`;
</script>

<template>
  <div class="q-mt-md line-height-15">
    Les méthodes pour récupérer
    <a
      href="#get-/v1/datasets"
      title="Voir la méthode api de récupération d'une page de jeux de données"
    >
      la liste des jeux de données </a
    >,
    <a
      href="#get-/v1/datafiles"
      title="Voir la méthode api de récupération d'une page de fichiers de données"
    >
      la liste des fichiers de données
    </a>
    ou
    <a
      href="#get-/v1/datafiles/-rid-/rows"
      title="Voir la méthode api de récupération d'une page de données d'un millésime"
    >
      la liste des données d'un millésime
    </a>
    renvoient une liste paginée d'enregistrements et suivent le même modèle de
    pagination. La liste d’objets est encapsulée dans un objet Pagination.
    <br /><br />
    Vous n’avez pas à calculer vous-même les pages précédentes et suivantes
    puisque les URL sont disponibles dans la réponse dans les attributs
    previousPage et nextPage.
    <br />
    Ils seront définis à null si il n’y a pas de page précédente et/ou suivante.
    <br /><br />
    Exemple pour une pagination de jeux de données :
    <!-- Highlighting code -->
    <DidoCodeHightlighting
      language="javascript"
      :code="codeExamplePagination"
    />
  </div>
</template>
